exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.invoice-create-page .item-table .item-body .item-row td[data-v-0913a39a] {\n  padding-left: 0px !important;\n}\n", ""]);

// exports
